import useTheme from 'hooks/useTheme'
import { Box, Flex } from 'vvs-uikit'
import { Swiper, SwiperSlide } from 'swiper/react'
import SwiperCore, { Autoplay, Pagination } from 'swiper'
import styled from 'styled-components'
import 'swiper/swiper.min.css'
import 'swiper/components/pagination/pagination.min.css'
import { useLocalStorage } from 'hooks/useLocalStorage'

import { IGOPromotionalBanner, IGO_ID, isExpired as isIgoExpired } from './IgoBanner'
import {
  MaintenanceBanner,
  isExpired as isMaintenanceEnded,
  storageKey as maintenanceStorageKey,
} from './MaintenanceBanner'
import { DefiraBanner, isExpired as isDefiraExpired, storageKey as defiraStorageKey } from './DefiraBanner'
import { FarmAprBanner, storageKey as farmAprStorageKey } from './FarmAprBanner'
import { FarmBoostBanner, storageKey as farmBoostStorageKey } from './FarmBoostBanner'
import { EcoBoostBanner, isExpired as isEcoExpired, storageKey as ecoBoostStorageKey } from './EcoBoostBanner'
import {
  VvsGotchiPromotionLiveBanner,
  isHidden,
  storageKey as vvvsGotchiLiveStorageKey,
} from './VvsGotchiPromotionLiveBanner'

SwiperCore.use([Autoplay, Pagination])

const StyledSwiperContainer = styled.div`
  ${({ theme }) => `
    background: ${theme.colors.secondary};
  `}

  .swiper-pagination-bullet {
    background: white;
  }
  .swiper-slide > * {
    height: 240px;
  }
  ${({ theme }) => theme.mediaQueries.sm} {
    .swiper-slide > * {
      height: 160px;
    }
  }
`

const PromotionBanner = () => {
  const { theme } = useTheme()
  const [inactiveBannerKey, setInactiveBannerKey] = useLocalStorage<string[]>('inactiveBannerKey', [])

  const addKey = (key: string) => {
    setInactiveBannerKey([...inactiveBannerKey, key])
  }

  const banners = [
    !inactiveBannerKey.includes(farmAprStorageKey) && (
      <SwiperSlide key={farmAprStorageKey}>
        <Flex width="100%" justifyContent="center" alignItems="center" background={theme.colors.secondary}>
          <FarmAprBanner
            onCloseClick={() => {
              addKey(farmAprStorageKey)
            }}
          />
        </Flex>
      </SwiperSlide>
    ),
    !isMaintenanceEnded() && !inactiveBannerKey.includes(maintenanceStorageKey) && (
      <SwiperSlide key="maintenance">
        <Flex width="100%" justifyContent="center" alignItems="center" background={theme.colors.secondary}>
          <MaintenanceBanner
            onCloseClick={() => {
              addKey(maintenanceStorageKey)
            }}
          />
        </Flex>
      </SwiperSlide>
    ),
    !isIgoExpired() && !inactiveBannerKey.includes(IGO_ID) && (
      <SwiperSlide key="igo">
        <Flex width="100%" justifyContent="center" alignItems="center" background={theme.colors.secondary}>
          <IGOPromotionalBanner onClick={() => addKey(IGO_ID)} />
        </Flex>
      </SwiperSlide>
    ),
    !isHidden(inactiveBannerKey) && (
      <SwiperSlide key="vvsGotchiLive">
        <Flex width="100%" justifyContent="center" alignItems="center" background={theme.colors.secondary}>
          <VvsGotchiPromotionLiveBanner
            onCloseClick={() => {
              addKey(vvvsGotchiLiveStorageKey)
            }}
          />
        </Flex>
      </SwiperSlide>
    ),
    !isEcoExpired() && !inactiveBannerKey.includes(ecoBoostStorageKey) && (
      <SwiperSlide key={ecoBoostStorageKey}>
        <Flex width="100%" justifyContent="center" alignItems="center" background={theme.colors.secondary}>
          <EcoBoostBanner
            onCloseClick={() => {
              addKey(ecoBoostStorageKey)
            }}
          />
        </Flex>
      </SwiperSlide>
    ),
    !inactiveBannerKey.includes(farmBoostStorageKey) && (
      <SwiperSlide key={farmBoostStorageKey}>
        <Flex width="100%" justifyContent="center" alignItems="center" background={theme.colors.secondary}>
          <FarmBoostBanner
            onCloseClick={() => {
              addKey(farmBoostStorageKey)
            }}
          />
        </Flex>
      </SwiperSlide>
    ),
    !isDefiraExpired() && !inactiveBannerKey.includes(defiraStorageKey) && (
      <SwiperSlide key="defira">
        <Flex width="100%" justifyContent="center" alignItems="center" background={theme.colors.secondary}>
          <DefiraBanner
            onCloseClick={() => {
              addKey(defiraStorageKey)
            }}
          />
        </Flex>
      </SwiperSlide>
    ),
  ].filter((b) => b)

  if (banners.length <= 0) return null

  return (
    <StyledSwiperContainer>
      <Box mx="10px">
        <Swiper
          loop={banners.length >= 2}
          autoplay={banners.length >= 2 ? { delay: 5000 } : undefined}
          pagination={{ clickable: true }}
        >
          {banners}
        </Swiper>
      </Box>
    </StyledSwiperContainer>
  )
}

export default PromotionBanner
